var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-rubik font-light text-xs",domProps:{"innerHTML":_vm._s(`${_vm.icon} ${_vm.name}`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }